import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { searched } from "../../features/jobs/jobsSlice";

function SearchFilter() {
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();

  const searchTextHandler = (e) => {
    dispatch(searched(e.target.value));

    setSearchText(e.target.value);
  };
  return (
    <div className="search-field group flex-1">
      <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
      <input
        type="text"
        placeholder="Search Job"
        className="search-input"
        id="lws-searchJob"
        value={searchText}
        onChange={searchTextHandler}
      />
    </div>
  );
}

export default SearchFilter;
